exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".card-content[data-v-12e72381]{display:flex;overflow:hidden;text-overflow:ellipsis;word-wrap:break-word;white-space:pre-line}.card_image[data-v-12e72381]{width:auto;height:auto;background-position:50%;background-size:cover;background-repeat:no-repeat;position:relative}.hashed_image_canvas[data-v-12e72381]{width:100%;height:100%;position:absolute;top:0;opacity:1;transition:opacity .3s ease-in}.hashed_image_canvas canvas[data-v-12e72381],img[lazy=loaded][data-v-12e72381]{width:100%;height:100%}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-12e72381","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Card.vue
// module id = 525
// module chunks = 0